module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "logs-tab-container",
      "element-loading-background": "#F7F8FC"
    }
  }, [(!_vm.loading && _vm.activityLogs.length === 0) ? _c('div', [_vm._v("\n    Not enough data has been gathered yet to display any results\n  ")]) : _c('div', [_vm._l((_vm.activityLogs), function(log) {
    return _c('el-card', {
      key: log.id,
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_c('div', {
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('strong', [_vm._v(_vm._s(log.user))]), _vm._v(" - " + _vm._s(_vm.formatDate(log.date_created)) + "\n      ")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(log.action))])])
  }), _vm._v(" "), (_vm.loading && _vm.activityLogs.length > 0) ? _c('div', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons-container"
  }, [(!_vm.loading && _vm.hasNext) ? _c('el-button', {
    staticClass: "load-button",
    attrs: {
      "type": "primary",
      "size": "small",
      "plain": ""
    },
    on: {
      "click": _vm.loadMore
    }
  }, [_vm._v("Load More")]) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.hasPrevious) ? _c('el-button', {
    staticClass: "load-button",
    attrs: {
      "type": "primary",
      "size": "small",
      "plain": ""
    },
    on: {
      "click": _vm.loadPrevious
    }
  }, [_vm._v("Load Previous")]) : _vm._e()], 1), _vm._v(" "), (!_vm.loading && _vm.activityLogs.length > 0 && !_vm.hasNext && !_vm.hasPrevious) ? _c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "20px"
    }
  }, [_vm._v("End of logs")])]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00bddf5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/permission/profile/tabs/ActivityLogsTab.vue
// module id = 3112
// module chunks = 3